module.exports = __webpack_public_path__ + "img/banner_title_mobile_en.6d38d764.gif";